import LanguageService from '../shared/LanguageService';
import * as types from './actionTypes';

export function loadLanguageSuccess(language: any) {
    return { type: types.LOAD_LANGUAGE_SUCCESS, language };
}

export function loadLanguage(
    requestedLanguage: string = null,
    applicationVersion: string = null,
    translationsVersion: string = null
) {
    return (dispatch: any) =>
        LanguageService.init(requestedLanguage, applicationVersion, translationsVersion).then(
            (language: any) => {
                dispatch(loadLanguageSuccess(language));
            }
        );
}
